import React from 'react';
import styles from "../styles.module.scss"
import { formattedPrice } from '../../../../../views/pages/manage/unAssigned/collectPayment/utils';

const NewReceipts = ({
    newReceipts
}) => {


    return ( 
        <div className='a-card m-0 mt-3 d-flex flex-column'>

            <h3>New Receipts</h3>

            <hr className='w-100'/>

            <table className={styles['new-receipts-table']}>
                <tr className={`${styles['heading-row']}`}>
                    <th>Payment Mode</th>
                    <th>Paymode Amount</th>
                </tr>

                {
                    newReceipts?.map(({paymentMode, paidAmount}) => 
                        <tr key={paymentMode}>
                            <td>{paymentMode}</td>
                            <td className={styles['amount']}>{formattedPrice(paidAmount)}</td>
                        </tr>
                    )
                }
            </table>

        </div>
     );
}
 
export default NewReceipts;